module.exports = __webpack_public_path__ + "static/media/accial-logo-horizontal-white.248e1a3e.png";